import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'donationCreate';

const reducersKeys = {
  createDonateFormRequest: 'createDonateFormRequest',
  createDonateFormSuccess: 'createDonateFormSuccess',
  createDonateFormFailure: 'createDonateFormFailure',
};

const initialState = {
  loaded: false,
  loading: false,
  error: null,
};

const donateFormCreate = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.createDonateFormRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    [reducersKeys.createDonateFormSuccess]: (state) => {
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.createDonateFormFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const donateFormCreateReducers = createReducerNames(name, reducersKeys);
export const { actions } = donateFormCreate;

export default donateFormCreate.reducer;
